import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { LEGAL } from "../data/content";

const quick = [
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Impact", to: "/impact" },
  { label: "Get Involved", to: "/get-involved" },
];
const getInvolved = [
  { label: "Volunteer", to: "/get-involved?tab=volunteer" },
  { label: "Donate", to: "/donate" },
  { label: "Partner With Us", to: "/get-involved?tab=partner" },
  { label: "Request Support", to: "/get-involved?tab=support" },
];
const socials = [Facebook, Instagram, Linkedin];

export function Footer() {
  return (
    <footer className="brand-ink text-white" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-8">
        <div className="mb-14 flex justify-center border-b border-white/10 pb-12">
          <img src="/thefrent-logo-dark-tight.png" alt="Thefrent Foundation — Educate. Empower. Elevate." className="h-64 w-auto md:h-80" draggable={false} data-testid="footer-logo" />
        </div>
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <FooterCol title="Quick Links" items={quick} />
          <FooterCol title="Get Involved" items={getInvolved} />

          <div>
            <h4 className="overline txt-gold">Contact Us</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/75">
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 txt-gold" /> {LEGAL.email}</li>
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 txt-gold" /> {LEGAL.phone}</li>
              <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 txt-gold" /> {LEGAL.impactLine}</li>
            </ul>
          </div>

          <div>
            <h4 className="overline txt-gold">Follow Us</h4>
            <div className="mt-5 flex gap-3">
              {socials.map((Icon, i) => (
                <a key={i} href="#" aria-label="Social" data-testid={`footer-social-${i}`} className="grid h-10 w-10 place-items-center rounded-full ring-1 ring-white/20 text-white/80 transition-colors hover:brand-gold-bg hover:text-[#0d1d47]">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
            <p className="mt-3 text-[0.65rem] uppercase tracking-[0.18em] text-white/40" data-testid="footer-social-coming-soon">
              Coming soon
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center gap-2 border-t border-white/10 pt-6 text-center text-xs text-white/50 sm:flex-row sm:justify-center sm:gap-3">
          <span>© {new Date().getFullYear()} {LEGAL.name} All rights reserved.</span>
          <span className="hidden text-white/20 sm:inline">·</span>
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/60 transition-colors hover:text-[#e0b25a]">Privacy Policy</Link>
          <span className="hidden text-white/20 sm:inline">·</span>
          <Link to="/terms" data-testid="footer-terms-link" className="text-white/60 transition-colors hover:text-[#e0b25a]">Terms of Use</Link>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <h4 className="overline txt-gold">{title}</h4>
      <ul className="mt-5 space-y-3 text-sm">
        {items.map((it) => (
          <li key={it.label}>
            <Link to={it.to} className="text-white/75 transition-colors hover:text-[#e0b25a]">{it.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
